import { render } from "./ExpiringPoints.vue?vue&type=template&id=62cafc89&scoped=true&ts=true"
import script from "./ExpiringPoints.vue?vue&type=script&lang=ts"
export * from "./ExpiringPoints.vue?vue&type=script&lang=ts"

import "./ExpiringPoints.vue?vue&type=style&index=0&id=62cafc89&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62cafc89"]])

export default __exports__